import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";
import "./index.less";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import "./i18n";

// ✅ AntD
import { ConfigProvider } from "antd";
import enUS from "antd/es/locale/en_US";
import frFR from "antd/es/locale/fr_FR";

// ✅ Moment (for AntD v4)
import moment from "moment";
import "moment/locale/fr";

// ✅ Dayjs (for custom usage)
import dayjs from "dayjs";
import "dayjs/locale/fr";

// optional plugins (recommended)
import relativeTime from "dayjs/plugin/relativeTime";
import advancedFormat from "dayjs/plugin/advancedFormat";
import i18n from "./i18n";

dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);

export const client = new QueryClient();

const activePage = window.location.pathname.replace("/", "");

const getLocale = () => {
  const lang = i18n.language;

  if (lang === "fr") {
    moment.locale("fr");
    dayjs.locale("fr");
    return frFR;
  } else {
    moment.locale("en");
    dayjs.locale("en");
    return enUS;
  }
};

let base64Val = "";
let nameVal = "";
let MIMEtypeVal = "";

// Note : This function is needed
function uploadDocumentApp(base64, name, MIMEtype) {
  base64Val = base64;
  nameVal = name;
  MIMEtypeVal = MIMEtype;
}

const Root = () => {
  const [locale, setLocale] = React.useState(() => {
    const lang = i18n.language;
    if (lang === "fr") {
      moment.locale("fr");
      dayjs.locale("fr");
      return frFR;
    }
    moment.locale("en");
    dayjs.locale("en");
    return enUS;
  });

  React.useEffect(() => {
    const handleLanguageChange = (lng) => {
      if (lng === "fr") {
        moment.locale("fr");
        dayjs.locale("fr");
        setLocale(frFR);
      } else {
        moment.locale("en");
        dayjs.locale("en");
        setLocale(enUS);
      }
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  return (
    <ConfigProvider locale={locale}>
      <Provider store={store}>
        <QueryClientProvider client={client}>
          <PersistGate loading={null} persistor={persistor}>
            <App
              activePage={activePage}
              isApp={window.location.search.indexOf("app") >= 0}
              documentData={{ base64Val, nameVal, MIMEtypeVal }}
            />
          </PersistGate>

          {process.env.NODE_ENV === "development" && (
            <ReactQueryDevtools position="bottom-right" />
          )}
        </QueryClientProvider>
      </Provider>
    </ConfigProvider>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));
